import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd0bf4b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-info" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "limit-map-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "limits"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "has-value"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "200000", -1))
const _hoisted_9 = { class: "btn" }
const _hoisted_10 = { class: "btn-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_road_map = _resolveComponent("road-map")!

  return (_openBlock(), _createElementBlock("div", {
    class: "pc-item-root",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('enter-table', _ctx.mdata)))
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { innerHTML: _ctx.gameTypeLabel }, null, 8, _hoisted_2),
        _createElementVNode("span", null, "F" + _toDisplayString(_ctx.mdata.tableNo), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_road_map, {
          class: "map",
          borderColor: '#ccc',
          mapData: _ctx.mdata.result,
          beadRowCount: 13,
          display: 5,
          gameType: _ctx.mdata.gameType
        }, null, 8, ["mapData", "gameType"]),
        (_ctx.activetable === _ctx.mdata.tableNo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limits, (limit) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "limit",
                  onClick: _withModifiers(($event: any) => (_ctx.playTable(limit)), ["stop"]),
                  key: `pc-limit-${limit.Id}`
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('common.min')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(limit.Min), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('common.max')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(limit.Max), 1),
                  (_ctx.isValidUserInfo(0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_5))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_7,
      _createElementVNode("div", null, _toDisplayString(_ctx.t('common.singlelimit')), 1),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('common.enter')), 1)
      ])
    ])
  ]))
}